import React from 'react';
import './QuotePage.css';

import { PageTitle } from '../../../components';
import { GetQuote } from '../..';



const QuotePage = () => {

  return (

    <div className='quote-page'>

      {/* Page Title */}
      <PageTitle title={'Get Quote'} page={'Get Quote'} />

      {/* Booking Form */}
      <GetQuote />

    </div>

  );

}

export default QuotePage;